export default /* glsl */ `
vWipeFactor = (position.x - 0.2) / 6.5;
#include <begin_vertex>
`;
